import { FC, useCallback } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import classNames from 'classnames';
import { Button, Input } from 'antd';
import { onKeyDown } from '../../hooks';
import { sendToAmplitude, useFormData } from '../../model';
import { passwordValidation } from './lib';
import s from './index.module.css';

type SignUpProps = {
    next: (pass: string) => void;
};

export const LogPass: FC<SignUpProps> = ({ next }) => {
    const { setEmail } = useFormData();
    const {
        control,
        formState: { errors },
        watch
    } = useFormContext();
    const email = watch('email');
    const pass = watch('password');
    const disabled = !!errors.password || !!errors.email || !email || !passwordValidation(pass);

    const handleNext = useCallback(() => {
        if (!disabled) {
            sendToAmplitude(`WALLARMCOM_AASM_SIGNUP_FORM_PASSWORD_SUBMITTED`);
            setEmail(email);
            next(pass);
        }
    }, [disabled, email, pass]);

    return (
        <>
            <Controller
                name='email'
                control={control}
                rules={{ required: 'Please complete this required field' }}
                render={({ field }) => (
                    <Input
                        {...field}
                        size='large'
                        placeholder='Work or SSO email'
                        onKeyDown={e => onKeyDown(e, handleNext)}
                        onBlur={() =>
                            sendToAmplitude(`WALLARMCOM_AASM_SIGNUP_FORM_EMAIL`, {
                                email: field.value
                            })
                        }
                    />
                )}
            />

            <Controller
                name='password'
                control={control}
                rules={{
                    required: 'Please complete this required field',
                    validate: passwordValidation
                }}
                render={({ field }) => (
                    <Input.Password
                        {...field}
                        size='large'
                        placeholder='Password'
                        onFocus={() => sendToAmplitude(`WALLARMCOM_AASM_SIGNUP_FORM_PASS`)}
                        onKeyDown={e => onKeyDown(e, handleNext)}
                    />
                )}
            />

            <p className={classNames({ [s.error]: errors.password?.type === 'validate' })}>
                At least 8 characters containing at least 1 number, 1 special character, 1 lowercase
                letter and 1 uppercase letter
            </p>

            <Button type='primary' block size='large' onClick={handleNext} disabled={disabled}>
                Create account
            </Button>
        </>
    );
};
